import React from "react";
import Header from "../../../components/ui/Header";
import Footer from "../../../components/ui/Footer";
import WhatsAppButton from "../../../components/ui/WhatsAppButton";

const Oratory = () => {
    return (
        <div className="text-gray-900 min-h-screen flex flex-col">
            <Header />

            <main className="flex-1 w-full pt-20 pb-16 px-5 md:px-16 flex flex-col md:flex-row items-center justify-between gap-10">

                {/* IMAGEN – arriba en móvil */}
                <div className="md:w-1/2 flex justify-center order-1 md:order-2">
                    <img
                        src="/assets/images/oratory.jpg"
                        alt="Oratory"
                        className="rounded-2xl shadow-lg w-full max-w-sm md:max-w-full"
                    />
                </div>

                {/* TEXTO */}
                <div className="md:w-1/2 space-y-5 order-2 md:order-1">

                    <h1 className="text-3xl sm:text-4xl md:text-6xl font-headline font-bold text-indigo-900 leading-tight">
                        REDACCIÓN Y ORATORIA PARA EJECUTIVOS
                        <span className="block w-20 h-1 bg-purple-400 rounded-full mt-3"></span>
                    </h1>

                    <p className="text-base md:text-lg leading-relaxed text-justify text-gray-700">
                        Escribir es un entrenamiento que implica elevar el nivel de lectura y comprensión
                        de textos. En una era dominada por la tecnología, muchos profesionales presentan
                        serias deficiencias incluso en la elaboración de informes o comunicaciones simples.
                    </p>

                    <p className="text-base md:text-lg leading-relaxed text-justify text-gray-700">
                        Ofrecemos capacitaciones <strong>In House</strong> eminentemente prácticas,
                        donde enseñamos a usar las palabras de forma adecuada, estructurar oraciones claras
                        y fortalecer la comunicación para manejar públicos diversos y resolver conflictos.
                    </p>

                    <p className="text-base md:text-lg leading-relaxed text-justify text-gray-700">
                        La forma en que escribimos refleja la forma en que pensamos y nos comunicamos.
                        Una deficiente redacción afecta la credibilidad, prestigio y empatía de cualquier
                        profesional u organización. Mejorar esta habilidad transforma profundamente la
                        comunicación interpersonal y organizacional.
                    </p>

                    <p className="text-base md:text-lg leading-relaxed text-justify text-gray-700">
                        Además, realizamos evaluación de personal, asesorías en selección y terapias
                        especializadas para directivos, aplicando técnicas de{" "}
                        <strong>Coaching Ontológico</strong> que integran mente, pensamiento, cuerpo,
                        espíritu, valores y lenguaje.
                    </p>

                    <p className="text-base md:text-lg font-semibold text-indigo-900 text-justify">
                        Toma el control de tu comunicación: capacitaciones prácticas para profesionales.
                    </p>
                </div>

                <WhatsAppButton />
            </main>

            <Footer />
        </div>
    );
};

export default Oratory;
